"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapInCustHookChangeError = exports.InjectHook = exports.CreateHookInjection = void 0;

var react_1 = __importDefault(require("react"));

var errors_1 = require("../utils/errors");

exports.CreateHookInjection = function (hook) {
  var Wrappers = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    Wrappers[_i - 1] = arguments[_i];
  }

  return function (Component) {
    function HookWrapper(props, ref) {
      var extraProps = hook(props);

      var AllProps = __assign(__assign(__assign({}, props), extraProps), {
        ref: ref
      });

      var rendered = react_1.default.createElement(Component, __assign({}, AllProps));

      for (var i = Wrappers.length - 1; i >= 0; --i) {
        var Wrapper = Wrappers[i];
        rendered = react_1.default.createElement(Wrapper, __assign({}, AllProps, {
          children: rendered
        }));
      }

      return rendered;
    }

    var useConnectedComponent = react_1.default.forwardRef(HookWrapper);
    return useConnectedComponent;
  };
};

exports.InjectHook = function (Component, hook) {
  var Wrappers = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    Wrappers[_i - 2] = arguments[_i];
  }

  return exports.CreateHookInjection.apply(void 0, __spread([hook], Wrappers))(Component);
};

exports.WrapInCustHookChangeError = function (Component) {
  var HookChangeBoundary =
  /** @class */
  function (_super) {
    __extends(HookChangeBoundary, _super);

    function HookChangeBoundary() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.state = {
        key: 0
      };

      _this.componentDidCatch = function (error, info) {
        if (!(error instanceof errors_1.HookChangeError)) {
          throw error;
        }

        error.hasBeenCaught = true;

        _this.setState(function (_a) {
          var key = _a.key;
          return {
            key: key + 1
          };
        });
      };

      return _this;
    } // TODO: do something about refs


    HookChangeBoundary.prototype.render = function () {
      return react_1.default.createElement(Component, __assign({}, this.props, {
        key: this.state.key
      }));
    };

    return HookChangeBoundary;
  }(react_1.default.Component);

  return HookChangeBoundary;
};